module.exports = __webpack_public_path__ + "static/img/icon_game_11.1f42a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_11.png
// module id = ZI+9
// module chunks = 0